import React from 'react';
import {NavLink} from 'react-router-dom';
import {RxHamburgerMenu} from 'react-icons/rx';

import './Navigation.css';
import Logo from '../media/logosmall.png';
import {mainNav, moreNav} from '../content/navLinks';

const NAV_COLLAPSE_ID = 'navbarSupportedContent';

function closeNavbarAndDropdown() {
  // Close the mobile collapse if open
  const collapseEl = document.getElementById(NAV_COLLAPSE_ID);
  if (collapseEl) {
    collapseEl.classList.remove('show');
  }

  // Close any open Bootstrap dropdowns (safely)
  document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
    menu.classList.remove('show');
  });
  document.querySelectorAll('.dropdown-toggle.show').forEach((toggle) => {
    toggle.classList.remove('show');
    toggle.setAttribute('aria-expanded', 'false');
  });
}

function NavItem({to, label, className = 'nav-link'}) {
  return (
    <NavLink
      to={to}
      className={className}
      onClick={() => closeNavbarAndDropdown()}>
      {label}
    </NavLink>
  );
}

export default function Navigation() {
  return (
    <div className='Navigation'>
      <nav className='navbar navbar-expand-sm ps-2'>
        <NavLink
          to='/'
          className='navbar-brand'
          aria-label='Home'
          onClick={() => closeNavbarAndDropdown()}>
          <img
            src={Logo}
            alt='Jane Corry Home'
            className='smalllogo'
          />
        </NavLink>

        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target={`#${NAV_COLLAPSE_ID}`}
          aria-controls={NAV_COLLAPSE_ID}
          aria-expanded='false'
          aria-label='Toggle navigation'>
          <span className='navbar-toggler-icon'>
            <RxHamburgerMenu />
          </span>
        </button>

        <div
          className='collapse navbar-collapse'
          id={NAV_COLLAPSE_ID}>
          <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
            {mainNav.map((item) => (
              <li
                className='nav-item'
                key={item.to}>
                <NavItem
                  to={item.to}
                  label={item.label}
                />
              </li>
            ))}

            <li className='nav-item dropdown'>
              {/* Keep dropdown toggle as Bootstrap expects */}
              <button
                className='nav-link dropdown-toggle'
                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'>
                More
              </button>

              <ul className='dropdown-menu'>
                {moreNav.map((item) => (
                  <li key={item.to}>
                    <NavItem
                      to={item.to}
                      label={item.label}
                      className='dropdown-item'
                    />
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
